import { gql, useQuery } from '@apollo/client'

export const LIST_COMPLIANCE_EXEMPTIONS = gql`
  query ListComplianceExemptions($cursor: DateTimeIDCursor, $limit: Int) {
    complianceExemptionList(cursor: $cursor, limit: $limit) {
      exemptions {
        patientId
        reason
        categories
        detail
        createdAt
        updatedAt
      }
      pageInfo {
        endCursor
      }
    }
  }
`

export const GET_COMPLIANCE_EXEMPTION = gql`
  query GetComplianceExemption($patientId: ID!) {
    complianceExemption(patientId: $patientId) {
      patientId
      reason
      categories
      detail
      createdAt
      updatedAt
    }
  }
`

export const useComplianceExemptionList = (options = {}) =>
  useQuery(LIST_COMPLIANCE_EXEMPTIONS, {
    fetchPolicy: 'cache-and-network',
    ...options,
  })
